import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

<template>
  <div
    class="flex-col flex items-center justify-center text-center h-36 border border-dashed rounded-sm border-gray-200"
    data-test-box-empty-state
    {{mergeClasses}}
    ...attributes
  >
    <p class="text-base text-black mb-2">
      {{@title}}
    </p>
    <p class="text-sm text-gray-500 leading-normal mb-2">
      {{@description}}
    </p>
  </div>
</template>
